<template>
  <div>
    <ul>
      <li
        class="libox"
        v-for="(item, index) in list"
        :key="index"
        :id="'card' + (index + 1)"
      >
        <div
          @touchstart="touchstart($event, item)"
          @touchmove="touchMove($event, item)"
          @touchend="touchEnd($event, item)"
          v-show="item.name !== selectItem.name"
        >
          {{item.name}}
          <svg
            class="icon svg-icon"
            aria-hidden="true"
          >
            <use :xlink:href="item.icon"></use>
          </svg>
        </div>
      </li>
      <li
        v-show="selectItem.name"
        class="selectBox"
        ref="selectBox"
      >
        {{selectItem.name}}
        <svg
          class="icon svg-icon"
          aria-hidden="true"
        >
          <use :xlink:href="selectItem.icon"></use>
        </svg>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 列表数据
      list: [
        { name: '1', selected: true, icon: '#icon-mianxingbenzivg' },
        { name: '2', selected: true, icon: '#icon-mianxingchizi' },
        { name: '3', selected: true, icon: '#icon-mianxingdiannao' },
        { name: '4', selected: true, icon: '#icon-mianxingdayinji' },
        { name: '5', selected: true, icon: '#icon-mianxingdingshuqi' },
        { name: '6', selected: true, icon: '#icon-mianxingheiban' },
        { name: '7', selected: true, icon: '#icon-mianxinggangbi' },
        { name: '8', selected: true, icon: '#icon-mianxingboshimao' },
        { name: '9', selected: true, icon: '#icon-mianxingjisuanqi' },
        { name: '10', selected: true, icon: '#icon-mianxinghuaxue' },
        { name: '11', selected: true, icon: '#icon-mianxingqianbi' },
        { name: '12', selected: true, icon: '#icon-mianxingshubao' },
        { name: '13', selected: true, icon: '#icon-mianxingshuicaibi' },
        { name: '14', selected: true, icon: '#icon-mianxingtushu' },
      ],
      // 选中元素内容
      selectItem: {},
      timeOutEvent: 0,
      oldNodePos: {
        x: 0,
        y: 0,
      },
      oldMousePos: {
        x: 0,
        y: 0,
      },
      oldIndex: 0,
      // 长按标识
      longClick: 0,
    }
  },
  created() {
    document.addEventListener(
      'touchmove',
      function (e) {
        e.preventDefault()
      },
      { passive: false }
    )
  },
  watch: {
    oldIndex(newVal) {
      const oldIndex = this.list.findIndex(
        (r) => r.name === this.selectItem.name
      )
      this.list.splice(oldIndex, 1)

      console.log(oldIndex, 'oldIndex')
      console.log(newVal, 'newVal')

      console.log(this.selectItem, 'this.selectItem')
      this.list.splice(newVal, 0, this.selectItem)
    },
  },
  methods: {
    touchstart(ev, item) {
      this.longClick = 0
      const that = this
      const selectDom = ev.currentTarget // div元素
      this.timeOutEvent = setTimeout(() => {
        that.longClick = 1
        that.selectItem = item
        // 元素初始位置
        that.oldNodePos = {
          x: selectDom.offsetLeft,
          y: selectDom.offsetTop,
        }
        // 鼠标原始位置
        that.oldMousePos = {
          x: ev.touches[0].pageX,
          y: ev.touches[0].pageY,
        }
        const lefts = that.oldMousePos.x - that.oldNodePos.x // x轴偏移量
        const tops = that.oldMousePos.y - that.oldNodePos.y // y轴偏移量
        const { pageX, pageY } = ev.touches[0] // 手指位置
        that.$refs.selectBox.style.left = `${pageX - lefts}px`
        that.$refs.selectBox.style.top = `${pageY - tops}px`
      }, 500)
    },
    touchMove(ev) {
      clearTimeout(this.timeOutEvent)
      const selectDom = ev.currentTarget.parentNode // li元素
      if (this.longClick === 1) {
        const lefts = this.oldMousePos.x - this.oldNodePos.x // x轴偏移量
        const tops = this.oldMousePos.y - this.oldNodePos.y // y轴偏移量
        const { pageX, pageY } = ev.touches[0] // 手指位置
        this.$refs.selectBox.style.left = `${pageX - lefts}px`
        this.$refs.selectBox.style.top = `${pageY - tops}px`
        this.cardIndex(selectDom, pageX, pageY)
      }
    },
    touchEnd() {
      clearTimeout(this.timeOutEvent)
      this.selectItem = {}
    },
    /**
     * 计算当前移动卡片位于卡片的哪一行哪一列
     */
    cardIndex(selDom, moveleft, movetop) {
      const liWid = selDom.clientWidth
      const liHei = selDom.clientHeight
      const newWidthNum = Math.ceil(moveleft / liWid) // 哪一列
      const newHeightNum = Math.ceil(movetop / liHei) // 哪一行
      const newPositionNum = (newHeightNum - 1) * 4 + newWidthNum
      if (this.oldIndex !== newPositionNum - 1) {
        if (newPositionNum <= this.list.length) {
          this.oldIndex = newPositionNum - 1
        } else {
          this.oldIndex = this.list.length - 1
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin myFlexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  overflow: hidden;
  .libox {
    width: 25%;
    height: 100px;
    border-right: 1px dashed #cccccc;
    border-bottom: 1px dashed #cccccc;
    box-sizing: border-box;
    @include myFlexCenter;
    > div {
      width: calc(100% - 10px);
      height: 75px;
      border-radius: 18px;
      @include myFlexCenter;
      position: relative;
      &::after {
        content: '';
        width: 100%;
        height: 100%;
        background: rgba(255, 177, 177, 0.3);
        position: absolute;
        top: 0;
        left: 0;
      }
      > svg {
        width: 75px;
        height: 75px;
      }
    }
  }
  .selectBox {
    position: absolute;
    width: calc(25% - 10px);
    height: 75px;
    border-radius: 18px;
    > svg {
      width: 75px;
      height: 75px;
    }
    background-color: rgba(0, 0, 0, 0.1);
    color: white;
    @include myFlexCenter;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
  }
}
</style>